import React from 'react'
import { AccordionTab } from 'primereact/accordion'

import './CustomAccordionTab.css'

export default function CustomAccordionTab({ header, children }) {
  return <AccordionTab header={header}>{children}</AccordionTab>
}
